import {Box, IconButton} from '@mui/material';
import { slideLeft, slideRight, slideLeftDis, slideRightDis} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';

type Props = {
  scrollLeft: () => void;
  scrollRight: () => void;
  disableLeft: boolean;
  disableRight: boolean;
};

const SlideArrow = (props: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      {/* Left Arrow */}
      <Image
                        src={props.disableLeft?slideLeftDis:slideLeft}
                        alt="left arrow"
                        onClick={props.disableLeft?()=>{}:props.scrollLeft}
                        height={30}
                        width={30}
                        style={{objectFit:'cover',filter: 'drop-shadow(0px 2.4px 2.4px rgba(0, 0, 0, 0.25))',cursor: 'pointer', overflow: 'visible' }} 

                        
                      />

      {/* Right Arrow */}
      <Image
                        src={props.disableRight?slideRightDis:slideRight}
                        alt="Right arrow"
                        onClick={props.disableRight?()=>{}:props.scrollRight}                        
                        height={30}
                        width={30}
                        style={{objectFit:'cover',filter: 'drop-shadow(0px 2.4px 2.4px rgba(0, 0, 0, 0.25))',cursor: 'pointer', overflow:"visible" }}
                      />
    </Box>
  );
};

export default SlideArrow;
